/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Raven          from "raven-js";
import configureRaven from "../lib/raven";
import configureAxios from "../lib/axios";
import boot           from "../lib/boot";

$(function() {
  configureRaven();
  configureAxios();

  Raven.context(function() {
    boot.init()
  });

  function getParam(p) {
    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  function getExpiryRecord(value) {
    var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

    var expiryDate = new Date().getTime() + expiryPeriod;
    return {
      value: value,
      expiryDate: expiryDate
    };
  }

  function addGclid() {
    var gclidParam = getParam('gclid');
    var gclidFormFields = ['gclid_field', 'foobar']; // all possible gclid form field ids here
    var gclidRecord = null;
    var currGclidFormField;

    var gclsrcParam = getParam('gclsrc');
    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    gclidFormFields.forEach(function (field) {
      if (document.getElementById(field)) {
        currGclidFormField = document.getElementById(field);
      }
    });

    if (gclidParam && isGclsrcValid) {
      gclidRecord = getExpiryRecord(gclidParam);
      localStorage.setItem('gclid', JSON.stringify(gclidRecord));
    }
    var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
    var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

    if (currGclidFormField && isGclidValid) {
      currGclidFormField.value = gclid.value;
    }
  }

  function addMsclkid() {
    var msclkidParam = getParam('msclkid');
    var msclkidFormFields = ['msclkid_field']; // all possible msclkid form field ids here
    var msclkidRecord = null;
    var currMsclkidFormField;

    msclkidFormFields.forEach(function (field) {
      if (document.getElementById(field)) {
        currMsclkidFormField = document.getElementById(field);
      }
    });

    if (msclkidParam) {
      msclkidRecord = getExpiryRecord(msclkidParam);
      localStorage.setItem('msclkid', JSON.stringify(msclkidRecord));
    }
    var msclkid = msclkidRecord || JSON.parse(localStorage.getItem('msclkid'));
    var isMsclkidValid = msclkid && new Date().getTime() < msclkid.expiryDate;

    if (currMsclkidFormField && isMsclkidValid) {
      currMsclkidFormField.value = msclkid.value;
    }
  }

  window.addEventListener('load', addGclid);
  window.addEventListener('load', addMsclkid);
});
